import { BACKEND } from '../constants';

export const BACKENDSKILLS = {
    category: BACKEND,
    skills: [
        {
            category: BACKEND,
            skill: 'Node.js',
            level: 8,
        },
        {
            category: BACKEND,
            skill: 'Express.js',
            level: 7,
        },
        {
            category: BACKEND,
            skill: 'PostgreSQL',
            level: 8,
        },
        {
            category: BACKEND,
            skill: 'RESTful API',
            level: 7,
        },
        {
            category: BACKEND,
            skill: 'MongoDB',
            level: 7,
        },
        {
            category: BACKEND,
            skill: 'GraphQL',
            level: 5,
        },

        {
            category: BACKEND,
            skill: 'Database Architecture',
            level: 5,
        },
        {
            category: BACKEND,
            skill: 'Redis / Caching',
            level: 4,
        },
    ],
};
